import { CSSObject } from 'styled-components';

const ellipsis = (hasEllipsis: boolean): CSSObject => {
  return hasEllipsis
    ? {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        wordWrap: 'break-word',
        whiteSpace: 'nowrap',
      }
    : {};
};

export default ellipsis;
